import auth from "./authentication";
import company from "./company";
import station from "./station";
import district from "./district";
import upazila from "./upazila";
import seatPlan from "./seatPlan";
import tripRoute from "./tripRoute";
import paymentGateway from "./paymentGateway";
import templateDecks from "./templateDecks";
import agentUserReg from "./agentUserReg";
import busType from "./busType";
import selectedSeatClass from "./selectedSeatClass";
import counterPanelTripSearch from "./counterPanelTripSearch";
import contentManagement from "./contentManagement";

const rootReducer = {
    auth,
    company,
    district,
    upazila,
    station,
    seatPlan,
    tripRoute,
    paymentGateway,
    templateDecks,
    agentUserReg,
    busType,
    selectedSeatClass,
    counterPanelTripSearch,
    contentManagement,
};

export default rootReducer;
